export default "__VITE_ASSET__Blhf5BpE__"